import { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { api } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [profile, setProfile] = useState(null);
  const [token, setToken]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) { setUser(session.user); setToken(session.access_token); fetchProfile(session.access_token); }
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) { setUser(session.user); setToken(session.access_token); fetchProfile(session.access_token); }
      else { setUser(null); setToken(null); setProfile(null); }
    });
    return () => subscription.unsubscribe();
  }, []);

  async function fetchProfile(t) {
    try { const p = await api.getMe(t); setProfile(p); } catch(e) { console.error(e); }
  }

  async function signUp(email, password, full_name) {
  const { data, error } = await supabase.auth.signUp({
    email, password,
    options: { data: { full_name } }
  });
  if (error) throw new Error(error.message);
  return data;
}

  async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw new Error(error.message);
  setUser(data.user);
  setToken(data.session.access_token);
  await fetchProfile(data.session.access_token);
  return data;
  }

  async function signOut() {
    if (token) await api.logout(token).catch(() => {});
    await supabase.auth.signOut();
  }

  async function updateProfile(updates) {
    const p = await api.updateMe(updates, token);
    setProfile(p); return p;
  }

  return (
    <AuthContext.Provider value={{ user, profile, token, loading, signUp, signIn, signOut, updateProfile, refreshProfile: () => fetchProfile(token) }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
